import { render } from "./FileNode.vue?vue&type=template&id=13ac860c&scoped=true"
import script from "./FileNode.vue?vue&type=script&lang=js"
export * from "./FileNode.vue?vue&type=script&lang=js"

import "./FileNode.vue?vue&type=style&index=0&id=13ac860c&scoped=true&lang=css"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ac860c"]])

export default __exports__